module.exports = __webpack_public_path__ + "static/images/styles/images/landing/landing-award-large.RU.d9d781c3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/landing/landing-award-large.RU.png
// module id = 3649
// module chunks = 11